import { GatewayConfiguration, ProjectClient, UXAContextClient } from '@contentsquare/uxanalytics-client';
import { mergeWith } from 'lodash';
import { ResourceService } from '../services/resources/resource.service';
import { ResourceTag, TranslationProject } from '../models/resource';
import { ClientFactory } from '../services/app.client.factory';
import { EntityService } from '../services/entity-service';
import { PermissionService } from '../services/permission.service';
import { TranslationResourceUtils } from '../services/resources/translation-resource.utils.service';
import { UxaContextService } from '../services/uxa-context.service';
export class AppContext {
    constructor(projectId, config, token, permissions, resources) {
        this._projectId = projectId;
        this._config = config;
        this._token = token;
        this._permissions = permissions;
        this._resources = resources;
        this._entities = new EntityService(projectId, config);
    }
    get resources() {
        return this._resources;
    }
    get permissions() {
        return this._permissions;
    }
    get projectId() {
        return this._projectId;
    }
    get project() {
        return this._project;
    }
    get config() {
        return this._config;
    }
    get userId() {
        return this._token.userId;
    }
    get user() {
        return this._token.body.user;
    }
    get jwt() {
        return this._token.jwt;
    }
    get state() {
        return this._state;
    }
    get entities() {
        return this._entities;
    }
    static async build(projectId, config, token, resources = []) {
        const ctx = new AppContext(projectId, config, token);
        ClientFactory.init(new GatewayConfiguration(config.apiUrl, token.jwt));
        ctx._permissions = new PermissionService(token.userId);
        ctx._state = new UxaContextService(projectId, ClientFactory.get(UXAContextClient));
        ctx._resources = new ResourceService();
        ctx._entities = new EntityService(projectId, config);
        const [project] = await Promise.all([
            ClientFactory.get(ProjectClient).get(projectId),
            ctx.permissions.init(projectId),
            ctx._state.init(),
            ctx._resources.init(resources),
        ]);
        ctx._project = project;
        return ctx;
    }
    async getTranslations() {
        if (this.config.featureFlags.lokalise) {
            await this.resources.addResources(TranslationResourceUtils.getDescriptors(this.config, {
                name: 'translations',
                project: TranslationProject.UXA,
            }));
        }
        return mergeWith({}, ...this.resources.getTranslations(this.config.locale, this.config.isSDK ? ResourceTag.SDK : ResourceTag.WEB));
    }
    getModuleTranslations(...modules) {
        const resolvedModuleTranslations = modules
            .map((module) => this.resources.getModuleTranslations(module, this.config.locale, this.config.isSDK ? ResourceTag.SDK : ResourceTag.WEB))
            .reduce((acc, translations) => {
            acc.push(...translations);
            return acc;
        }, []);
        return mergeWith({}, ...resolvedModuleTranslations);
    }
    static getToken(context) {
        return context._token;
    }
}
//# sourceMappingURL=app.context.js.map